var _ellipse, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParkeringsplads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "PARKERINGSPLADS",
    clipPath: "url(#clip0_0_1)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2",
    cx: 8,
    cy: 8,
    rx: 6,
    ry: 7,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_5844_45823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.591 0H0V15.591H15.591V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.89605 0.0335229C4.46068 0.311492 2.27359 1.74784 1.03321 3.88384C0.564938 4.69028 0.264961 5.5265 0.087164 6.52133C-0.00413331 7.03217 -0.0268902 8.15565 0.0425197 8.72506C0.321449 11.0131 1.56978 13.0271 3.50801 14.3163C3.89653 14.5746 4.663 14.9625 5.11013 15.1269C5.49754 15.2693 6.21737 15.4507 6.67118 15.5203C7.16191 15.5954 8.44316 15.5968 8.89851 15.5226C10.7082 15.2279 12.1445 14.4931 13.3737 13.2332C14.221 12.3647 14.8091 11.412 15.1847 10.2991C15.3763 9.73157 15.557 8.86355 15.5631 8.48136C15.5648 8.38058 15.5712 8.36415 15.591 8.41024C15.6064 8.44586 15.6164 8.1842 15.6159 7.76561C15.6154 7.37808 15.6054 7.09475 15.5936 7.13597C15.5783 7.18934 15.5661 7.14041 15.5511 6.96609C15.4761 6.09162 15.1683 5.06579 14.7241 4.20951C13.534 1.91554 11.304 0.359914 8.75588 0.0461456C8.34913 -0.0039555 7.28751 -0.0111513 6.89605 0.0335229ZM5.12707 2.641C4.95186 2.7203 4.8405 2.828 4.74201 3.01335L4.66234 3.16327V7.7806V12.3979L4.74671 12.5697C4.84527 12.7704 4.99341 12.9033 5.19238 12.9694C5.30919 13.0082 5.45889 13.0149 6.03282 13.0071L6.73115 12.9976L6.87135 12.9152C6.94846 12.8698 7.05343 12.7821 7.10458 12.7203C7.28448 12.5028 7.28583 12.4867 7.28583 10.5635V8.815H8.06655C8.89755 8.815 9.28202 8.78634 9.6714 8.69537C10.3311 8.54123 10.7921 8.30143 11.2244 7.88761C11.8896 7.25078 12.2035 6.29985 12.0849 5.28028C11.914 3.81011 10.9429 2.86011 9.36963 2.62397C9.12683 2.58751 8.70761 2.57905 7.1659 2.57944C5.31516 2.57989 5.25822 2.58163 5.12707 2.641ZM7.28583 5.69399V6.71622L7.93795 6.71586C8.77087 6.71541 8.91068 6.68362 9.16754 6.43636C9.54095 6.07686 9.51666 5.24412 9.12329 4.91968C8.88582 4.7238 8.75696 4.69715 7.98293 4.68381L7.28583 4.67179V5.69399ZM0.0129268 7.79559C0.0129268 8.18312 0.0172144 8.34164 0.0224313 8.14789C0.0276483 7.95414 0.0276483 7.63707 0.0224313 7.4433C0.0172144 7.24952 0.0129268 7.40807 0.0129268 7.79559Z",
    fill: "#041C3C"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkeringsplads);
export default __webpack_public_path__ + "static/media/PARKERINGSPLADS.7abff88ab4f0fce3b43d4d2a54b073cb.svg";
export { ForwardRef as ReactComponent };